import { render, staticRenderFns } from "./ActivityScoreModal.vue?vue&type=template&id=6a138192&scoped=true"
import script from "./ActivityScoreModal.vue?vue&type=script&lang=js"
export * from "./ActivityScoreModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityScoreModal.vue?vue&type=style&index=0&id=6a138192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a138192",
  null
  
)

export default component.exports